import React, { useContext } from "react"
import Gettext, { GettextInterface } from "@indeed/indeed-gettext"

const I18nContext = React.createContext(Gettext({ indeed: {}, "": {} }))

export const I18nProvider = I18nContext.Provider

export const useI18n = (): GettextInterface => useContext(I18nContext)
